import React from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";

const LayoutDefault = ({ children }) => (
  <>
    {/* removed header animation from here . To be added -- reveal-from-bottom */}
    <Header navPosition="right" className="" />
    <main className="site-content">{children}</main>
    <Footer />
  </>
);

export default LayoutDefault;
